import {KRAKEN_URL} from "../data/constants";
import {BUILD_VERSION} from "./buildInfo";

/**
 * Add the deploy version to a Kraken image URL.
 *
 * Kraken serves logos at fixed URLs and sends no Cache-Control header. Thus a
 * browser keeps an old copy for weeks after a designer replaces the file in
 * Drive. Each deploy has a new build version, so after a deploy the URL is
 * new and the browser loads the file again. CloudFront does not put the query
 * in its cache key, thus the CDN keeps one copy of each file.
 *
 * Use the result only as an <img> src. Scenes, default rows and
 * PRODUCT_LOGO_CYCLES keep the URL without the version: code compares these
 * URLs and finds the GDN copies by file name.
 */
export function withDeployVersion(url: string, version: string = BUILD_VERSION): string {
  if (version === "unknown" || !url.startsWith(`${KRAKEN_URL}/`)) return url;
  const hashAt = url.indexOf("#");
  const base = hashAt === -1 ? url : url.slice(0, hashAt);
  const fragment = hashAt === -1 ? "" : url.slice(hashAt);
  const separator = base.includes("?") ? "&" : "?";
  return `${base}${separator}v=${encodeURIComponent(version)}${fragment}`;
}
